// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-time-sheet.page.title': 'Time Sheets',
    'team-member-time-sheet.page.archive.title': 'Archived Time Sheets',
    'team-member-time-sheet.page.search_results': 'Search Results',
    'team-member-time-sheet.page.create.title': 'Create New Time Sheet',
    'team-member-time-sheet.page.search.title': 'Find Time Sheets',
    'team-member-time-sheet.page.edit.title': 'Edit Time Sheet',
    'team-member-time-sheet.page.view.title': 'Time Sheet',
    'team-member-time-sheet.page.all': 'All',

    'team-member-time-sheet.button.cancel': 'Cancel',
    'team-member-time-sheet.button.select': 'Select',
    'team-member-time-sheet.button.find': 'Find Time Sheets',
    'team-member-time-sheet.button.search': 'Apply',
    'team-member-time-sheet.button.create': 'Save Time Sheet',
    'team-member-time-sheet.button.new': 'New Time Sheet',
    'team-member-time-sheet.button.save': 'Save Changes',
    'team-member-time-sheet.button.archive': 'Archive',
    'team-member-time-sheet.button.approve': 'Approve',
    'team-member-time-sheet.button.decline': 'Decline',
    'team-member-time-sheet.button.delete': 'Permanently Delete',
    'team-member-time-sheet.button.edit': 'Edit',
    'team-member-time-sheet.button.restore': 'Restore',
    'team-member-time-sheet.button.reset': 'Reset',

    'team-member-time-sheet.placeholder.search': 'Search time sheets',

    'team-member-time-sheet.link.create_first_team_member_time_sheet': 'Click here to create your first time sheet',
    'team-member-time-sheet.link.team_member_time_sheets': 'Return to Time Sheets',
    'team-member-time-sheet.link.archive': 'Archived Time Sheets',
    'team-member-time-sheet.link.retry': 'Click here to retry',

    'team-member-time-sheet.checkbox.all': 'Check All',
    'team-member-time-sheet.checkbox.actions_label': 'with selected',

    'team-member-time-sheet.label.team_member_name': 'Team Member',

    'team-member-time-sheet.label.time_in': 'Time In',
    'team-member-time-sheet.label.from__time_in': 'From Time In',
    'team-member-time-sheet.label.to__time_in': 'To Time In',

    'team-member-time-sheet.label.time_out': 'Time Out',
    'team-member-time-sheet.label.from__time_out': 'From Time Out',
    'team-member-time-sheet.label.to__time_out': 'To Time Out',

    'team-member-time-sheet.label.from__minutes_worked': 'From minutes worked',
    'team-member-time-sheet.label.to__minutes_worked': 'To minutes worked',
    'team-member-time-sheet.label.minutes_worked': 'Minutes Worked',

    'team-member-time-sheet.label.from__approved_at': 'From approved at',
    'team-member-time-sheet.label.to__approved_at': 'To approved at',
    'team-member-time-sheet.label.approved_at': 'Approved At',

    'team-member-time-sheet.label.from__declined_at': 'From declined at',
    'team-member-time-sheet.label.to__declined_at': 'To declined at',
    'team-member-time-sheet.label.declined_at': 'Declined At',

    'team-member-time-sheet.label.approved_by_user_name': 'Approved By User',
    'team-member-time-sheet.label.declined_by_user_name': 'Declined By User',

    'team-member-time-sheet.label.payroll_hourly_type_name': 'Payroll Hourly Type',

    'team-member-time-sheet.label.rate': 'Rate',

    'team-member-time-sheet.label.from__created_at': 'From created at',
    'team-member-time-sheet.label.to__created_at': 'To created at',
    'team-member-time-sheet.label.created_at': 'Created At',

    'team-member-time-sheet.label.from__updated_at': 'From updated at',
    'team-member-time-sheet.label.to__updated_at': 'To updated at',
    'team-member-time-sheet.label.updated_at': 'Updated At',

    'team-member-time-sheet.label.from__deleted_at': 'From deleted at',
    'team-member-time-sheet.label.to__deleted_at': 'To deleted at',
    'team-member-time-sheet.label.deleted_at': 'Deleted At',

    'team-member-time-sheet.label.status': 'Status',

    'team-member-time-sheet.sort.field_label': 'Field',
    'team-member-time-sheet.sort.direction_label': 'Direction',
    'team-member-time-sheet.sort.direction_ascending': 'Ascending',
    'team-member-time-sheet.sort.direction_descending': 'Descending',

    'team-member-time-sheet.modal.title.team_member_time_sheet_decline': 'Decline Time Sheet',
    'team-member-time-sheet.modal.title.team_member_time_sheet_approve': 'Approve Time Sheet',
    'team-member-time-sheet.modal.title.team_member_time_sheet_archive': 'Archive Time Sheet',
    'team-member-time-sheet.modal.title.team_member_time_sheet_delete_permanently': 'Delete Time Sheet',
    'team-member-time-sheet.modal.title.team_member_time_sheet_restore': 'Restore Time Sheet',

    'team-member-time-sheet.modal.message.team_member_time_sheet_decline': 'Are you sure that you want to decline this time sheet? | Are you sure that you want to decline these time sheets?',
    'team-member-time-sheet.modal.message.team_member_time_sheet_approve': 'Are you sure that you want to approve this time sheet? | Are you sure that you want to approve these time sheets?',
    'team-member-time-sheet.modal.message.team_member_time_sheet_archive': 'Are you sure that you want to move this time sheet to the archive? | Are you sure that you want to move these time sheets to the archive?',
    'team-member-time-sheet.modal.message.team_member_time_sheet_delete_permanently':
        'Are you sure that you want to permanently delete this time sheet? This action cannot be undone. | Are you sure that you want to permanently delete these time sheets? This action cannot be undone.',
    'team-member-time-sheet.modal.message.team_member_time_sheet_restore': 'Are you sure that you want to restore this time sheet? | Are you sure that you want to restore these time sheets?',

    'team-member-time-sheet.success.message.team_member_time_sheet_created': 'Your time sheet has been created',
    'team-member-time-sheet.success.message.team_member_time_sheet_updated': 'Your time sheet has been updated',
    'team-member-time-sheet.success.message.team_member_time_sheet_restored': 'Your time sheet has been restored | All selected time sheets were restored',
    'team-member-time-sheet.success.message.team_member_time_sheet_deleted': 'Your time sheet has been permanently deleted | All selected time sheets were permanently deleted',
    'team-member-time-sheet.success.message.archived_team_member_time_sheets': 'Your time sheet was moved to the archive | All selected time sheets were moved to the archive',
    'team-member-time-sheet.success.message.approved_team_member_time_sheets': 'Your time sheet was approved | All selected time sheets were approved',
    'team-member-time-sheet.success.message.declined_team_member_time_sheets': 'Your time sheet was declined | All selected time sheets were declined',

    'team-member-time-sheet.error.message.declined_team_member_time_sheets': 'This time sheet was already declined | These time sheets were already declined',
    'team-member-time-sheet.error.message.approved_team_member_time_sheets': 'This time sheet was already approved | These time sheets were already approved',
    'team-member-time-sheet.error.message.approve_not_allowed_team_member_time_sheets': 'This time sheet is no longer pending and cannot be approved | These time sheets are no longer pending and cannot be approved',
    'team-member-time-sheet.error.message.decline_not_allowed_team_member_time_sheets': 'This time sheet is no longer pending and cannot be declined | These time sheets are no longer pending and cannot be declined',
    'team-member-time-sheet.error.message.archived_team_member_time_sheets': 'This time sheet was already moved to the archive | These time sheets were already moved to the archive',
    'team-member-time-sheet.error.message.team_member_time_sheet_deleted': 'This time sheet was already permanently deleted | These time sheets were already permanently deleted',
    'team-member-time-sheet.error.message.team_member_time_sheet_restored': 'This time sheet was already restored | These time sheets were already restored',
    'team-member-time-sheet.error.message.error_loading_page': 'Sorry, there was an error loading time sheet.| Sorry, there was an error loading time sheets.',

    'team-member-time-sheet.message.search.no_archived_team_member_time_sheets': "You haven't archived any team any member any time any sheets as yet.",

    'time-sheet-csv.page.import.title': 'Import Hours Worked',
    'time-sheet-csv.button.import': 'Import Hours',
    'time-sheet-csv.page.note': 'Please ensure to click the check mark if your file already includes headers.',
    'time-sheet-csv.page.required_fields': 'Required Fields',
    'time-sheet-csv.page.all_fields': 'All Fields',
    'time-sheet-csv.page.message.column_names': 'Column names are in the first line',
    'time-sheet-csv.page.message.field': 'Field',
    'time-sheet-csv.page.message.column': 'Column',
    'time-sheet-csv.page.instructions': 'Below are two sample files which will show the fields used in the import process.',

    'time-sheet-csv.success.message.time_sheets_imported': 'Your hours worked are being imported. We will email you when the import is complete.',
    'time-sheet-csv.error.message.csv_is_blank': "It looks like the CSV file is empty. No worries — just take a moment to double-check your file, and feel free to try again whenever you're ready!",
    'time-sheet-csv.error.message.invalid_file_type': 'Sorry, we only support CSV files. Please try again with a CSV file.',
};
